/**
 * 生成随机图表id
 */
function generateRandomKey(prefix) {
    if (prefix == null) {
        prefix = 'chart'
    }

    var userAgent = window.navigator.userAgent
        .replace(/[^a-zA-Z0-9]/g, '')
        .split('')
    var mid = ''
    for (var i = 0; i < 12; i++) {
        mid += userAgent[Math.round(Math.random() * (userAgent.length - 1))]
    }
    var time = new Date().getTime()

    return prefix + '_' + mid + '_' + time
}
/**
 * 深度克隆数据,包括对象，数组，map
 * @param {*} obj 对象，数组，map
 */
function deepCopy(obj) {
    if (!isObject(obj) && !isMap(obj)) {
        return obj;
    }

    let cloneObj;
    if (isMap(obj)) {
        cloneObj = new Map();
        for (let key of obj.keys()) {
            let value = obj.get(key);
            if (isMap(value) || isObject(value) || Array.isArray(obj)) {
                let copyVal = deepCopy(value);
                cloneObj.set(key, copyVal);
            } else {
                cloneObj.set(key, value);
            }
        }
    } else if (typeof obj === "function") {
        cloneObj = obj
    } else {
        cloneObj = Array.isArray(obj) ? [] : {};
        if (obj instanceof HTMLElement) {
            cloneObj = obj.cloneNode(true)
        } else {
            for (let key in obj) {
                // if (obj.hasOwnProperty(key)) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    cloneObj[key] =
                        isMap(obj[key]) || isObject(obj[key])
                            ? deepCopy(obj[key])
                            : obj[key];
                }
            }

        }
    }
    return cloneObj;
}

/**
 * 判断参数是否是Object类型
 * @param {*} o 
 */
function isObject(o) {
    return (
        !isMap(o) &&
        (typeof o === 'object' || typeof o === 'function') &&
        o !== null
    );
}

/**
 * 判断参数是否是Map类型
 * @param {*} obj 
 */
function isMap(obj) {
    if (obj instanceof Map) {
        return true;
    } else {
        return false;
    }
}

// 替换temp中的${xxx}为指定内容 ,temp:字符串，这里指html代码，dataarry：一个对象{"xxx":"替换的内容"}
// 例：luckysheet.replaceHtml("${image}",{"image":"abc","jskdjslf":"abc"})   ==>  abc
function replaceHtml(temp, dataarry) {
    return temp.replace(/\$\{([\w]+)\}/g, function (s1, s2) { var s = dataarry[s2]; if (typeof (s) != "undefined") { return s; } else { return s1; } });
}

function hasChinaword(s) {
    var patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
    if (!patrn.exec(s)) {
        return false;
    }
    else {
        return true;
    }
}

function insertNewChart(
    chartOptions,
    chart_id,
    chartAllType,
    chartData,
    rangeArray,
    rangeTxt,
    chartTheme,
    height,
    width,
    left,
    top
) {
    var chart_json = {}

    var chartAllTypeArray = chartAllType.split('|')

    var chartPro = chartAllTypeArray[0],
        chartType = chartAllTypeArray[1],
        chartStyle = chartAllTypeArray[2]

    chart_json.chart_id = chart_id
    chart_json.chartAllType = chartAllType
    chart_json.chartPro = chartPro
    chart_json.chartType = chartType
    chart_json.chartStyle = chartStyle

    chart_json.height = height
    chart_json.width = width
    chart_json.left = left
    chart_json.top = top

    //按照图表类型得到图表的默认设置
    var defaultOptionIni = chartOptions.defaultOption
    //数据的sheet索引
    chart_json.chartData = chartData
    chart_json.rangeArray = rangeArray
    chart_json.rangeTxt = rangeTxt

    //根据数据集得到按钮状态，rangeColCheck表示首列是否标题，rangeRowCheck表示首行是否标题，rangeConfigCheck表示是否转置。
    var rowColCheck = getRowColCheck(chartData)
    var rangeRowCheck = rowColCheck[0],
        rangeColCheck = rowColCheck[1],
        rangeConfigCheck = false

    chart_json.rangeColCheck = rangeColCheck
    chart_json.rangeRowCheck = rangeRowCheck
    chart_json.rangeConfigCheck = rangeConfigCheck

    //按照数据范围文字得到具体数据范围
    var rangeSplitArray = getRangeSplitArray(
        chartData,
        rangeArray,
        rangeColCheck,
        rangeRowCheck
    )
    chart_json.rangeSplitArray = rangeSplitArray

    //根据数据集、功能按钮状态、图表类型，得到图表可操作的数据格式，例如：{ "x":[], "y":[], series:[] }，可以按照次格式渲染数据页中的系列和轴控件。
    //数据为一行且为汉字的时候，chartDataCache的series为空数组
    var chartDataCache = getChartDataCache(
        chartData,
        rangeSplitArray,
        chartPro,
        chartType,
        chartStyle
    )
    chart_json.chartDataCache = chartDataCache

    //生成默认的系列顺序，默认根据series数组的位置，用户可以在界面上操作更改这个位置。
    var chartDataSeriesOrder = getChartDataSeriesOrder(
        chartDataCache.series[0].length
    )

    chart_json.chartDataSeriesOrder = chartDataSeriesOrder

    //设置图表皮肤
    chart_json.chartTheme = chartTheme

    //根据图表的默认设置、图表数据、图表系列顺序，等到一个完整的图表配置串。
    var defaultOption = addDataToOption(
        defaultOptionIni,
        chartDataCache,
        chartDataSeriesOrder,
        chartPro,
        chartType,
        chartStyle
    )

    //根据图表厂商选择渲染引擎，并根据设置渲染出图表
    chart_json.defaultOption = defaultOption
    return chart_json
}

export {
    isMap,
    isObject,
    deepCopy,
    generateRandomKey,
    replaceHtml,
    insertNewChart
}